import React from 'react';
import LoadingArtwork from './LoadingArtwork';
import { useSkinSettings } from './SkinContext';
import './CloudLoading.css';

export default function CloudLoading({ label = '正在准备页面…', fullPage = false, className = '', skin: skinOverride, period: periodOverride }) {
  const settings = useSkinSettings();
  const skin = skinOverride || settings.skin;
  const period = periodOverride || settings.period;

  return (
    <div className={`cloud-loading ${fullPage ? 'cloud-loading--full' : ''} ${className}`} data-skin={skin} data-period={period} role="status" aria-live="polite" aria-busy="true">
      <LoadingArtwork skin={skin} period={period} />
      <span className="cloud-loading-caption">{label}</span>
    </div>
  );
}
